import type { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { RichText as PrismicServicesRichText } from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

export type RichTextProps = SliceComponentProps<Content.RichTextSlice>;

const RichText = ({ slice }: RichTextProps) => {
  const { primary, variation } = slice;
  const { content } = primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <PrismicServicesRichText
      content={content}
      variant={variation}
      websiteUrl={WebsiteUrl}
    />
  );
};

export default RichText;
